import {Injectable} from "@angular/core"
import {MatDialog} from "@angular/material"
import {Observable} from "rxjs"
import {ConfirmationDialogComponent} from "app/common/services/confirmation/dialog/ConfirmationDialogComponent"

@Injectable({providedIn: "root"})
export class ConfirmationService {

    public constructor(private dialog: MatDialog) {

    }

    public open(message: string, title: string = "Confirm"): Observable<boolean> {
        const data = {title, message}
        return this.dialog.open(ConfirmationDialogComponent, {disableClose: true, data}).afterClosed()
    }
}
